module.exports = __webpack_public_path__ + "media/images/desktop/viewer_bg-e6325c1cf6aeb7f21dd6c0ba67e5ac7e.png";